import { createSlice } from "@reduxjs/toolkit";

const initialFormData = {
  applicationId: null,
  mobileNo: "",
  email: "",
  profession: "",
  gstin: "",
  panNumber: "",
  status: "",
  fundRequirement: 0,
  endUseOfFund: "",
  securityOffered: "",
  descriptionOfSecurity: "",
  udyamRegistrationNo: "",
  entityType: "",
  borrowerType: "",
  steps: "",
  totalSalesCurrentYear: 0,
  userId: null,
  estimatedCollateralValue: "",
};

const initialFiles = {
  company: null,
  directorsEquityStructure: null,
  annualFinancials: null,
  panCard: [],
  AadharCard: [],
  bankDetail: null,
  slLoanDetails: null,
  orderCopy: null,
  contractCopy: null,
  certification: null,
  creditRating: null,
  applicant: null,
  coApplicant: null,
  applicantIncome: null,
  coApplicantIncome: null,
  salarySlips: [],
  joiningLetter: null,

  // Adding new fields from website repo
  borrowerPanCard: null,
  moa: null,
  aoa: null,
  listOfDirector: null,
  shareholding: null,
  itr: [],
  balanceSheet: [],
  partnershipDeed: null,
  listOfPatner: null,
  incorporationDateProof: null,
  applicantPan: null,
  applicantAadhar: null,
  coApplicantPan: null,
  coApplicantAadhar: null,
  applicantForm16: null,
  coApplicantForm16: null,
  bankStatement: [],
  slLoan: [],
  gstDocx: null,
  as26: null,
  aadharCard: [],
  applicantItr: [],
  coApplicantItr: [],
};

const initialState = {
  passwordChange: {
    loading: false,
    error: null,
    success: false,
  },
  passwordReset: {
    loading: false,
    error: null,
    success: false,
  },
  user: [],
  locationFlag: true,
  ip: "",
  coordinates: {},
  tabIndex: 1,
  formData: initialFormData,
  files: initialFiles,
  activeStep: 0,
  notifications: [],
  resumed: false,
  isDocFetched: false,
  userEntityType: null,
  userBusinessType: null,
  userPermissions:[],
};

const userSlice = createSlice({
  name: "user",
  initialState: {
    ...initialState,
    user: JSON.parse(localStorage.getItem("user")) || [],
    locationFlag: true,
  },
  reducers: {
    // Password change reducers from admin project
    changePasswordStart: (state) => {
      state.passwordChange.loading = true;
      state.passwordChange.error = null;
      state.passwordChange.success = false;
    },
    changePasswordSuccess: (state) => {
      state.passwordChange.loading = false;
      state.passwordChange.success = true;
    },
    changePasswordFailure: (state, action) => {
      state.passwordChange.loading = false;
      state.passwordChange.error = action.payload;
    },
    resetPasswordStart: (state) => {
      state.passwordReset.loading = true;
      state.passwordReset.error = null;
      state.passwordReset.success = false;
    },
    resetPasswordSuccess: (state) => {
      state.passwordReset.loading = false;
      state.passwordReset.success = true;
    },
    resetPasswordFailure: (state, action) => {
      state.passwordReset.loading = false;
      state.passwordReset.error = action.payload;
    },
    clearPasswordStates: (state) => {
      state.passwordChange = initialState.passwordChange;
      state.passwordReset = initialState.passwordReset;
    },

    setUser: (state, { payload }) => {
      if (payload == null) {
        state.user = [];
      } else {
        state.user = payload;
      }
    },
    setLocationFlag: (state, { payload }) => {
      if (payload == null) {
        state.locationFlag = initialState.locationFlag;
      } else {
        state.locationFlag = payload;
      }
    },
    setIp: (state, { payload }) => {
      if (payload == null) {
        state.ip = initialState.locationFlag;
      } else {
        state.ip = payload;
      }
    },
    setCoordinates: (state, { payload }) => {
      if (payload == null) {
        state.coordinates = initialState.locationFlag;
      } else {
        state.coordinates = payload;
      }
    },
    setTabIndex: (state, { payload }) => {
      if (payload == null) {
        state.coordinates = initialState.locationFlag;
      } else {
        state.tabIndex = payload;
      }
    },
    setFormData: (state, { payload }) => {
      state.formData = payload ?? initialFormData;
    },
    updateFormField: (state, { payload }) => {
      const { field, value } = payload;
      if (!state.formData) {
        state.formData = { ...initialFormData };
      }
      state.formData[field] = value;
    },
    setFiles: (state, { payload }) => {
      state.files = payload ?? initialFiles;
    },
    updateFileField: (state, { payload }) => {
      const { field, value, index } = payload;

      const arrayFields = [
        "panCard",
        "AadharCard",
        "aadharCard",
        "bankStatement",
        "slLoan",
        "applicantItr",
        "coApplicantItr",
        "itr",
        "balanceSheet",
        "salarySlips",
      ];

      if (arrayFields.includes(field)) {
        if (!Array.isArray(state.files[field])) {
          state.files[field] = [];
        }

        if (typeof index === "number") {
          while (state.files[field].length <= index) {
            state.files[field].push(null);
          }
          state.files[field][index] = value;
        } else if (Array.isArray(value)) {
          state.files[field] = value;
        } else if (value) {
          const found = state.files[field].some(
            (f) => f && value && f.filename === value.filename
          );
          if (!found) {
            state.files[field] = [...state.files[field], value].filter(Boolean);
          }
        }
      } else {
        state.files[field] = value || null;
      }
    },
    setActiveStep: (state, { payload }) => {
      state.activeStep = payload ?? 0;
    },
    setNotiFications: (state, { payload }) => {
      state.notifications = payload ?? [];
    },
    setResumed: (state, { payload }) => {
      state.resumed = payload ?? false;
    },
    setIsDocFetched: (state, { payload }) => {
      state.isDocFetched = payload ?? false;
    },
    resetLoanApplication: (state) => {
      state.formData = initialFormData;
      state.files = initialFiles;
      state.activeStep = 0;
      state.resumed = false;
  },
    setLoanApplicationData: (state, { payload }) => {
      state.userEntityType = payload.userEntityType;
      state.userBusinessType = payload.userBusinessType;
    },
    clearLoanApplicationData: (state) => {
      state.userEntityType = null;
      state.userBusinessType = null;
    },
    setuserPermissions: (state, { payload }) => {
      state.userPermissions = payload ?? [];
    },
  },
});

export const {
  changePasswordStart,
  changePasswordSuccess,
  changePasswordFailure,
  resetPasswordStart,
  resetPasswordSuccess,
  resetPasswordFailure,
  clearPasswordStates,

  // User actions from web-front project
  setUser,
  setLocationFlag,
  setIp,
  setCoordinates,
  setTabIndex,
  setFormData,
  updateFormField,
  setFiles,
  updateFileField,
  setActiveStep,
  setNotiFications,
  setResumed,
  setIsDocFetched,
  resetLoanApplication,
  setLoanApplicationData,
  clearLoanApplicationData,
  setuserPermissions
} = userSlice.actions;

// Add selectors from web-front project
export const user = (state) => state.user.user;
export const locationFlag = (state) => state.user.locationFlag;
export const ip = (state) => state.user.ip;
export const coordinates = (state) => state.user.coordinates;
export const tabIndex = (state) => state.user.tabIndex;
export const selectFormData = (state) => state.user.formData;
export const selectFiles = (state) => state.user.files;
export const activeSteps = (state) => state.user.activeStep;
export const notifications = (state) => state.user.notifications;
export const resume = (state) => state.user.resumed;
export const isDocFetched = (state) => state.user.isDocFetched;
export const userPermissions = (state) => state.user.userPermissions;
export const selectLoanApplicationData = (state) => ({
  userEntityType: state.user.userEntityType,
  userBusinessType: state.user.userBusinessType
});

export default userSlice.reducer;
